import { openStaffPublicPreview } from "../../../utils/investorAdminPreviewAdapter";
import InvestorPortalActionButton from "./InvestorPortalActionButton";

export default function AdminPublicPreviewAction({
  opportunity,
  variant = "outline",
  fullWidth = true,
  label = "Preview public page",
}) {
  const handlePreview = () => {
    if (!opportunity?.slug && !opportunity?.id) return;
    openStaffPublicPreview(opportunity.slug || opportunity.id);
  };

  return (
    <InvestorPortalActionButton
      btnText={label}
      variant={variant}
      fullWidth={fullWidth}
      onClick={handlePreview}
    />
  );
}
